import { render, staticRenderFns } from "./BlackListContact.vue?vue&type=template&id=6ae3bee1&"
import script from "./BlackListContact.vue?vue&type=script&lang=ts&"
export * from "./BlackListContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports